import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { contextNameKey, worldEventInfo } from '../../utils/theFreaks';
import useFreaksT from './useFreaksT';
import { freaksSx as s } from './freaksStyles';

// Today in the Freakland world: the daily event (payday, lucky day, …) and the hot activity.
// Events this app doesn't know yet are left out.
export default function FreaksWorldBanner({ world }) {
  const { t } = useFreaksT();
  const events = (world ?? [])
    .map((event) => ({ event, info: worldEventInfo(event.key) }))
    .filter(({ info }) => info);
  if (!events.length) return null;
  return (
    <Box sx={s.card} data-testid="freaks-world">
      <Typography sx={{ ...s.small, ...s.muted, ...s.bold }}>{t('theFreaks.world.title')}</Typography>
      {events.map(({ event, info }) => (
        <Box key={`${event.key}-${event.context ?? ''}`} sx={{ ...s.row, mt: 0.5 }}>
          <Typography component="span" sx={{ mr: 0.75 }}>{info.emoji}</Typography>
          <Typography sx={{ ...s.grow, ...s.small }} data-testid={`freaks-world-${event.key}`}>
            {t(info.key, { context: event.context ? t(contextNameKey(event.context)) : '' })}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
